var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77902 3.36708C8.77902 5.15558 7.32911 6.60553 5.54057 6.60553C3.75204 6.60553 2.30212 5.15561 2.30212 3.36708C2.30212 1.57855 3.75204 0.128632 5.54057 0.128632C7.32911 0.128632 8.77902 1.57855 8.77902 3.36708Z",
    fill: "#141320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2818 4.56956C15.2818 5.90487 14.1993 6.98736 12.864 6.98736C11.5287 6.98736 10.4462 5.90487 10.4462 4.56956C10.4462 3.23426 11.5287 2.15176 12.864 2.15176C14.1993 2.15176 15.2818 3.23426 15.2818 4.56956Z",
    fill: "#141320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0886 11.4098V12.7334C11.0886 13.1538 10.7398 13.4935 10.3194 13.4935H0.760055C0.33966 13.4935 0 13.1538 0 12.7334V11.4098C0 9.37012 1.65409 7.71036 3.69369 7.71036H7.38738C8.2282 7.71036 9.00659 7.99308 9.62894 8.46672C10.512 9.14231 11.0885 10.2089 11.0885 11.4096L11.0886 11.4098Z",
    fill: "#141320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 10.4443V11.6853C16.9999 11.9185 16.8218 12.1168 16.5942 12.1351H11.933V11.3035C11.933 9.9743 11.318 8.78834 10.3578 8.01546C10.6663 7.88879 11.0022 7.82086 11.3566 7.82086H14.3729C15.8232 7.82086 17 8.99396 17 10.4443L16.9999 10.4443Z",
    fill: "#141320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuApproved);
export default __webpack_public_path__ + "static/media/menu-approved.d9ca60e951e4ded5b4fe946449a1ec4b.svg";
export { ForwardRef as ReactComponent };